(() => {
    'use strict';

    const subtitleType = 'auto';
    const isUserInterestedInTranslationTo = (lang) =>
        howspace.components.translator.isEnabled()
        && howspace.components.translator.getTargetLang() !== null
        && howspace.components.translator.getTargetLang().toLowerCase() === lang.toLowerCase()
        ;
    const isUserInterestedInTranslationFrom = (lang) =>
        howspace.components.translator.isEnabled()
        && howspace.components.translator.getTargetLang() !== null
        && howspace.components.translator.getTargetLang().toLowerCase() !== lang.toLowerCase()
        ;

    real.events.on('transcript:translated', notification => {
        if (!notification.object?.uploadedfile?.id) {
            return;
        }

        const result = notification.object;
        const uploadedFileId = result.uploadedfile.id;

        if (!isUserInterestedInTranslationTo(result.language)) {
            return;
        }

        const subtitle = {
            kind: 'subtitles',
            src: `${real.baseUri}/api/transcribe/subtitles?id=${uploadedFileId}&t9n=${result.language}`,
            srclang: result.language,
            label: `auto-generated (${result.language})`,
        };

        // Inform the UI new subtitles are available, so e.g. video players can add the subtitles.
        howspace.dispatchEvent($(document), howspace.components.videoPlayer.SUBTITLE_ADDED, {uploadedFileId, subtitle, subtitleType});

    });

    real.events.on('transcribe:finished', notification => {
        if (!notification.object?.uploadedfile?.id) {
            return;
        }

        const result = notification.object;
        const uploadedFileId = result.uploadedfile.id;
        // NOTE: Not sure why things are conditioned on the inline segments.
        const hasInlineSegments = result.have_inline_segments;

        const transcriptContainer = $(`.transcript-container[data-uploadedfile-id="${uploadedFileId}"]`);

        if (!hasInlineSegments) {
            howspace.animate(transcriptContainer, 'slideUp', 350, () => {
                transcriptContainer.removeAttr('style').addClass('d-none');
            });
        }

        if (transcriptContainer.hasClass('d-none') && hasInlineSegments) {
            howspace.animate(transcriptContainer, 'slideDown', 350, () => {
                transcriptContainer.removeAttr('style').removeClass('d-none');
            });
        }

        if (transcriptContainer) {
            transcriptContainer.find('.transcript-progress-wrapper').addClass('d-none');
            transcriptContainer.find('.transcript-content-wrapper').removeClass('d-none');
        }

        const subtitle = {
            kind: 'subtitles',
            src: `${real.baseUri}/api/transcribe/subtitles?id=${uploadedFileId}`,
            srclang: result.language,
            label: 'auto-generated',
        };
        // Inform the UI new subtitles are available, so e.g. video players can add the subtitles.
        howspace.dispatchEvent($(document), howspace.components.videoPlayer.SUBTITLE_ADDED, {uploadedFileId, subtitle, subtitleType});

        if (isUserInterestedInTranslationFrom(result.language)) {
            const lang = howspace.components.translator.getTargetLang().toLowerCase();
            const translatedSubtitle = {
                kind: 'subtitles',
                src: `${real.baseUri}/api/transcribe/subtitles?id=${uploadedFileId}&t9n=${lang}`,
                srclang: result.language,
                label: `auto-generated (${lang})`,
            };
            howspace.dispatchEvent($(document), howspace.components.videoPlayer.SUBTITLE_ADDED, {uploadedFileId, subtitle: translatedSubtitle, subtitleType});
        }
    });

})();
